import React, {Component} from 'react';
import {useParams} from 'react-router-dom';
import Intestazione from './components_novel/intestazione';
import Piedone from './components/piedone';
import Navbar from './components/navbar';
import Seo, {siteUrl} from './components/seo';
import {getArticlePath, getCreativeArticleBySlug} from './data/creativeArticles';

import logo from './images/Logo-Verso-Hemelslinn-2.webp';
import intestazioneBackgroundImage from './images/verso-hemelslinn-sfondo-2.webp';
import signatureImage from './images/firma.webp';

const authorPagePath = '/maurizio-feruglio/';
const authorId = `${siteUrl}${authorPagePath}#person`;

function articleFaqItems(article) {
  const pillarName = article.primaryPillar ? article.primaryPillar.title : 'archivio degli articoli';

  return [
    {
      question: 'Questo articolo fa parte di un percorso editoriale?',
      answer: `Si. L'articolo e collegato al percorso "${pillarName}" e al laboratorio narrativo di Verso Hemelslinn.`,
    },
    {
      question: 'Gli esempi sono collegati al romanzo?',
      answer:
        'Si. Gli articoli usano Verso Hemelslinn come campo di lavoro per osservare scelte narrative, personaggi, worldbuilding, relazioni e produzione editoriale.',
    },
    {
      question: 'Dove posso continuare la lettura?',
      answer:
        "Puoi continuare dal sommario del romanzo, dall'archivio degli articoli o dalla campagna crowdfunding dedicata al progetto editoriale.",
    },
  ];
}

const intestazioneBackgroundStyle = {
  backgroundImage: `url(${intestazioneBackgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundAttachment: 'fixed',
  height: '300px',
};

export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary.startsWith('/') ? urlOfTheLibrary : '/' + urlOfTheLibrary;
  script.async = true;
  document.body.appendChild(script);
}

class ArticlePage extends Component {
  state = {
    aNavbarLinks: [
      {id: 0, linkHref: '/', linkNome: 'ROMANZO'},
      {id: 1, linkHref: '/articoli', linkNome: 'ARTICOLI'},
    ],
  };

  renderArticle(article) {
    if (!article) {
      return (
        <section className="ftco-section creative-article-section">
          <div className="container">
            <div className="creative-article-shell">
              <p className="landing-kicker">Articolo non trovato</p>
              <h2>Questa rotta non è ancora tracciata</h2>
              <p>L’articolo che cerchi potrebbe essere stato spostato o non essere ancora pubblicato.</p>
              <a className="btn btn-info" href="/articoli">
                Torna all’archivio
              </a>
            </div>
          </div>
        </section>
      );
    }

    return (
      <section className="ftco-section creative-article-section">
        <div className="container">
          <article className="creative-article-shell">
            <p className="landing-kicker">{article.category || 'Scrittura creativa'}</p>
            <h1>{article.title}</h1>
            <p className="creative-article-subtitle">{article.subtitle}</p>
            <p className="creative-meta">
              {article.date} · {article.readingTime} · <a href={authorPagePath} rel="author">{article.author}</a>
            </p>
            <img
              className="creative-article-cover"
              src={article.cover}
              alt={article.coverAlt}
              style={{objectPosition: article.coverPosition || 'center center'}}
            />
            <div className="creative-article-body">
              {article.body.map((block, index) => this.renderBlock(block, index))}
            </div>
            {this.renderArticleFaq(article)}
            <aside className="creative-author-box">
              <img src={signatureImage} alt="Firma di Maurizio Feruglio" />
              <p>
                <a href={authorPagePath} rel="author">Maurizio Feruglio</a> è autore ed editore indipendente, fondatore di Eliosfera Editrice e autore della space opera romantica <em>Verso Hemelslinn</em>. Scrive di narrativa, personaggi, worldbuilding e relazioni nella fantascienza.
              </p>
              <a className="creative-text-link" href={authorPagePath}>Scopri l’autore</a>
            </aside>
            <div className="creative-article-actions">
              <a className="btn btn-info" href="/articoli">
                Archivio articoli
              </a>
              {article.mediumUrl ? (
                <a className="btn btn-outline-light" href={article.mediumUrl} target="_blank" rel="noreferrer noopener">
                  Leggi su Medium
                </a>
              ) : null}
            </div>
          </article>
        </div>
      </section>
    );
  }

  renderBlock(block, index) {
    if (typeof block === 'string') {
      return <p key={index}>{block}</p>;
    }

    if (block.type === 'heading') {
      return <h3 key={index}>{block.text}</h3>;
    }

    if (block.type === 'subheading') {
      return <h4 key={index}>{block.text}</h4>;
    }

    if (block.type === 'minorHeading') {
      return block.html ? (
        <h5 key={index} dangerouslySetInnerHTML={{__html: block.html}}></h5>
      ) : (
        <h5 key={index}>{block.text}</h5>
      );
    }

    if (block.type === 'html') {
      return <p key={index} dangerouslySetInnerHTML={{__html: block.html}}></p>;
    }

    if (block.type === 'quote') {
      const quoteHasEmphasis = block.html && /<em[\s>]/i.test(block.html);
      return (
        <blockquote className={quoteHasEmphasis ? 'quote-with-emphasis' : undefined} key={index}>
          {block.html ? (
            <p dangerouslySetInnerHTML={{__html: block.html}}></p>
          ) : (
            <p>{block.text}</p>
          )}
        </blockquote>
      );
    }


    if (block.type === 'image') {
      return (
        <figure className="creative-article-inline-image" key={index}>
          <img src={block.src} alt={block.alt || ''} />
          {block.caption ? <figcaption>{block.caption}</figcaption> : null}
        </figure>
      );
    }

    if (block.type === 'code') {
      return (
        <pre className="creative-article-code" key={index}>
          <code>{block.code}</code>
        </pre>
      );
    }

    if (block.type === 'list') {
      return (
        <ul className="creative-article-list" key={index}>
          {block.items.map((item) => {
            const itemKey = typeof item === 'string' ? item : item.html || item.text;
            return (
              <li key={itemKey}>
                {typeof item === 'string' ? item : item.html ? (
                  <span dangerouslySetInnerHTML={{__html: item.html}}></span>
                ) : (
                  item.text
                )}
              </li>
            );
          })}
        </ul>
      );
    }

    if (block.type === 'orderedList') {
      return (
        <ol className="creative-article-list" key={index}>
          {block.items.map((item) => {
            const itemKey = typeof item === 'string' ? item : item.html || item.text;
            return (
              <li key={itemKey}>
                {typeof item === 'string' ? item : item.html ? (
                  <span dangerouslySetInnerHTML={{__html: item.html}}></span>
                ) : (
                  item.text
                )}
              </li>
            );
          })}
        </ol>
      );
    }

    if (block.type === 'cta') {
      return (
        <p className="creative-article-cta" key={index}>
          <a className="btn btn-info" href={block.href} target="_blank" rel="noreferrer noopener">
            {block.label}
          </a>
        </p>
      );
    }

    if (block.type === 'internalLinks') {
      return (
        <nav className="creative-internal-links" aria-label="Link editoriali" key={index}>
          <h3>{block.title || 'Continua il viaggio'}</h3>
          <ul>
            {block.links.map((link) => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </nav>
      );
    }

    if (block.type === 'divider') {
      return <div className="creative-article-divider" key={index} aria-hidden="true">· · ·</div>;
    }

    return <p key={index}>{block.text}</p>;
  }

  renderArticleFaq(article) {
    const pillarHref = article.primaryPillar ? article.primaryPillar.path : '/articoli';
    const pillarLabel = article.primaryPillar ? article.primaryPillar.title : 'archivio degli articoli';

    return (
      <section className="seo-pillar-faq creative-article-faq" aria-labelledby="article-faq-title">
        <h2 id="article-faq-title">Domande frequenti</h2>
        <details open>
          <summary>Questo articolo fa parte di un percorso editoriale?</summary>
          <p>
            Si. L&apos;articolo e collegato al percorso <a href={pillarHref}>{pillarLabel}</a> e al laboratorio narrativo di <em>Verso Hemelslinn</em>.
          </p>
        </details>
        <details>
          <summary>Gli esempi sono collegati al romanzo?</summary>
          <p>
            Si. Gli articoli usano <em>Verso Hemelslinn</em> come campo di lavoro per osservare scelte narrative, personaggi, worldbuilding, relazioni e produzione editoriale.
          </p>
        </details>
        <details>
          <summary>Dove posso continuare la lettura?</summary>
          <p>
            Puoi continuare dal <a href="/summary">sommario del romanzo</a>, dall&apos;<a href="/articoli">archivio degli articoli</a> o dalla <a href="https://hemelslinn.s.gy/vh-web-hem-land">campagna crowdfunding</a>.
          </p>
        </details>
      </section>
    );
  }

  render() {
    const article = getCreativeArticleBySlug(this.props.slug);
    const articlePath = article ? getArticlePath(article) : `/articoli/${this.props.slug}/`;
    const articleDescription = article ? article.seoDescription || article.excerpt || article.subtitle : '';
    const headerBreadcrumbItems = [
      {
        label: 'ARTICOLI',
        href: '/articoli',
      },
      ...(article && article.primaryPillar ? [
        {
          label: 'PILASTRO',
          href: article.primaryPillar.path,
        },
      ] : []),
    ];
    const articleBreadcrumbItems = article ? [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Verso Hemelslinn',
        item: `${siteUrl}/`,
      },
      article.primaryPillar ? {
        '@type': 'ListItem',
        position: 2,
        name: article.primaryPillar.title,
        item: `${siteUrl}${article.primaryPillar.path}`,
      } : {
        '@type': 'ListItem',
        position: 2,
        name: 'Articoli',
        item: `${siteUrl}/articoli`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: article.title,
        item: `${siteUrl}${articlePath}`,
      },
    ] : [];
    const articleJsonLd = article ? {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Article',
          '@id': `${siteUrl}${articlePath}#article`,
          headline: article.title,
          description: articleDescription,
          image: {
            '@type': 'ImageObject',
            url: article.seoImage ? `${siteUrl}${article.seoImage}` : `${siteUrl}/images/copertina-verso-hemelslinn.webp`,
          },
          datePublished: article.publishedAt,
          dateModified: article.modifiedAt || article.publishedAt,
          inLanguage: 'it-IT',
          author: {
            '@id': authorId,
          },
          publisher: {
            '@type': 'Organization',
            name: 'Eliosfera Editrice',
          },
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': `${siteUrl}${articlePath}`,
          },
          isPartOf: {
            '@id': article.primaryPillar ? `${siteUrl}${article.primaryPillar.path}#webpage` : `${siteUrl}/#website`,
          },
          articleSection: article.primaryPillar ? article.primaryPillar.title : article.category,
          about: {
            '@id': `${siteUrl}/#book`,
          },
        },
        {
          '@type': 'BreadcrumbList',
          '@id': `${siteUrl}${articlePath}#breadcrumb`,
          itemListElement: articleBreadcrumbItems,
        },
        {
          '@type': 'FAQPage',
          '@id': `${siteUrl}${articlePath}#faq`,
          mainEntity: articleFaqItems(article).map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.answer,
            },
          })),
        },
      ],
    } : null;

    if (articleJsonLd && articleJsonLd['@graph'] && articleJsonLd['@graph'][0]) {
      articleJsonLd['@graph'][0].author = {
        '@id': authorId,
      };
    }

    return (
      <>
        <div className="page">
          <Seo
            title={article ? (article.seoTitle || article.title) : 'Articolo non trovato'}
            description={article ? articleDescription : 'Archivio degli articoli sulla scrittura creativa di Verso Hemelslinn.'}
            path={articlePath}
            image={article ? article.seoImage : '/images/copertina-verso-hemelslinn.webp'}
            type="article"
            noindex={!article}
            jsonLd={articleJsonLd}
          />
          <Navbar
            linkSito="/"
            logo={logo}
            deskLogo="Logo di Verso Hemelslinn"
            brandName="Verso Hemelslinn"
            aNavbarLinks={this.state.aNavbarLinks}
          />
          <div id="pagina" className="creative-article-page">
            <Intestazione
              pagina="ARTICOLI"
              paginaHref="/articoli"
              breadcrumbItems={headerBreadcrumbItems}
              backgroundStyle={intestazioneBackgroundStyle}
              titolo="SCRITTURA CREATIVA"
              titoloAs="p"
              romanzo="il laboratorio narrativo di"
              autore="VERSO HEMELSLINN"
            />

            {this.renderArticle(article)}

            <Piedone
              piedoneCallToAction="Le storie nascono da una domanda. Le rotte migliori da una scelta."
              piedoneLinkTermConditions=""
              piedoneLinkCookies="/cookies"
              piedoneLinkPrivacy="/privacy"
              piedoneIframe=""
              piedoneTwitter="https://x.com/Hemelslinn"
              piedoneInstagram="https://www.instagram.com/versohemelslinn/"
              piedoneFacebook="https://www.facebook.com/hemelslinn"
              piedoneTiktok="https://www.tiktok.com/@hemelslinn"
              piedoneDiscord=""
              piedonePinterest="https://it.pinterest.com/hemelslinn/"
              piedoneOpensea=""
              piedoneEliosfera="https://www.eliosfera.it/maurizio-feruglio-verso-hemelslinn-copertina-rigida-libro"
              piedoneYoutube="https://www.youtube.com/@VersoHemelslinn"
              piedoneCopyright="Eliosfera Editrice &copy;"
              piedoneCopyrightDisclaimer="Tutti i diritti riservati"
              piedoneCCBY='Template basato su <i class="icon-heart" aria-hidden="true"></i> <a href="https://colorlib.com" target="_blank">Colorlib</a>'
            />
          </div>

          {AddLibrary('js/jquery.min.js')}
          {AddLibrary('js/jquery-migrate-3.0.1.min.js')}
          {AddLibrary('js/jquery.waypoints.min.js')}
          {AddLibrary('js/jquery.stellar.min.js')}
          {AddLibrary('js/owl.carousel.min.js')}
          {AddLibrary('js/aos.js')}
          {AddLibrary('js/scrollax.min.js')}
          {AddLibrary('js/main.js')}
        </div>
      </>
    );
  }
}

function ArticleRoute({slug: fixedSlug}) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  return <ArticlePage slug={slug} />;
}

export default ArticleRoute;
